import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import svgFonts from "Layouts/Common/fontAwesome";
import FontAwesomeSvgIcon from "Layouts/Common/FontAwesomeSvgIcon";
import { Divider, useMediaQuery, useTheme } from "@mui/material";

type GlobalSearchFieldProps = {
  value?: string;
  placeholder?: string;
  onReset?: React.MouseEventHandler<HTMLButtonElement>;
  onSearch?: React.MouseEventHandler<HTMLButtonElement>;
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
};

export const GlobalSearchField: React.FC<GlobalSearchFieldProps> = ({
  placeholder,
  value,
  onChange,
  onSearch,
  onReset,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      onSearch?.(event as unknown as React.MouseEvent<HTMLButtonElement>);
    }
  };

  return (
    <Paper
      component="form"
      sx={{
        p: "2px 4px",
        margin: "10px 0",
        display: "flex",
        alignItems: "center",
        width: isMobile ? "100%" : 400,
      }}
      onSubmit={(e: React.FormEvent<HTMLFormElement>) => e.preventDefault()}
    >
      <InputBase
        value={value}
        sx={{ ml: 1, flex: 1 }}
        placeholder={placeholder}
        inputProps={{ "aria-label": placeholder }}
        onKeyDown={handleKeyDown}
        onChange={onChange}
      />
      <IconButton
        color="primary"
        sx={{ p: "5px" }}
        aria-label="global-search"
        onClick={onReset}
      >
        <FontAwesomeSvgIcon
          icon={svgFonts.faXmark}
          style={{ color: "rgb(0, 0, 0, 0.54)" }}
        />
      </IconButton>
      <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
      <IconButton
        type="button"
        sx={{ p: "10px" }}
        aria-label={placeholder}
        onClick={onSearch}
      >
        <FontAwesomeSvgIcon icon={svgFonts.faMagnifyingGlass} />
      </IconButton>
    </Paper>
  );
};
